import React from "react";
import classNames from "classnames";
import { ActivityBadge } from "./ActivityBadge";
import styles from "./ContentCard.module.css";

/**
 * Format review rating for display
 * @param {number} rating - Rating value (e.g., 4.5)
 * @param {number} reviewCount - Number of reviews
 * @returns {string|null} - Formatted rating string or null
 */
const formatRating = (rating, reviewCount) => {
  if (!rating || typeof rating !== "number") {
    return null;
  }
  const formattedRating = rating.toFixed(1);
  if (reviewCount && reviewCount > 0) {
    return `${formattedRating} (${reviewCount.toLocaleString()} reviews)`;
  }
  return formattedRating;
};

export const ContentCard = ({
  title,
  description,
  image,
  activities = [],
  hotelLink,
  className,
  imageStyle,
  onClick,
  rating,
  reviewCount,
  ...props
}) => {
  const formattedRating = formatRating(rating, reviewCount);

  return (
    <a
      className={classNames(styles.card, className, "custom_click_track")}
      onClick={onClick}
      {...props}
      href={hotelLink ? hotelLink.url : null}
      target={hotelLink?.target}
      rel={hotelLink?.rel}
    >
      <div className={styles.imageContainer}>
        {image && (
          <img
            src={image}
            alt={title}
            className={styles.image}
            style={imageStyle}
          />
        )}
        {activities.length > 0 && (
          <div className={styles.activities}>
            {activities.map((activity, index) => (
              <ActivityBadge key={index} activity={activity} />
            ))}
          </div>
        )}
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        {formattedRating && (
          <div className={styles.rating}>
            <span className={styles.ratingIcon}>★</span>
            <span className={styles.ratingText}>{formattedRating}</span>
          </div>
        )}
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </a>
  );
};
